<div class="chart-container-inner">
  <highcharts-chart #chart class="chart" [Highcharts]="highcharts" [constructorType]="chartConstructor" [options]="chartOptions" [(update)]="updateFlag" [callbackFunction]="chartCallback">
  </highcharts-chart>
</div>